import { useScreenDetect } from '@sgcmpteltd/uikit-next';
import cx from 'clsx';
import Image from 'next/image';

import {
  ListTypeLabel,
} from '@/app/(routes)/listing/_components/page-content/search-list/car-card/listing-type-label'; // @suppress longLineCheck
import { ContactItem } from '@/components/contact-item';
import { TextLink } from '@/components/text-link';
import { Tooltip } from '@/components/tooltip';
import { getFormattedDateString } from '@/utils/string/formattedDate';
import { joinSgcmMedia, joinSgcmSite } from '@/utils/url/join/public';
import { getInternalLink } from '@/utils/url/utm';

import { ICON_SIZE_IN_PIXEL, LIST_TYPE_LABEL_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Item: Component = ({
  submodelId,
  piDealer,
  onRemarkClick,
}) => {
  const { isDesktop } = useScreenDetect();
  const isDesktopMode = isDesktop();
  const {
    id, name, hotlines, adverts, updatedAt, whatsAppNumber,
  } = piDealer;
  // const [
  //   isDownpaymentModalOpen,
  //   setIsDownpaymentModalOpen,
  // ] = useState(false);

  // const handleDownpaymentClick = () => {
  //   setIsDownpaymentModalOpen(true);
  // };

  const convertPriceToText = (priceInt: number | null, unit?: string) => {
    if (priceInt === null) {
      return '-';
    }

    if (priceInt === 0) {
      return 'POA';
    }

    if (unit) {
      return `$${priceInt.toLocaleString()}${unit}`;
    }

    return `$${priceInt.toLocaleString()}`;
  };

  const piDealerLink = `${joinSgcmSite(`/new_cars/newcars_PIdealer.php?dcode=${id}`)}`;

  const selectedAdvert = adverts.find(
    advert => advert.subModelId === submodelId,
  );
  const hasStocks = selectedAdvert && selectedAdvert.stocks.length > 0;
  const hasRemark = selectedAdvert
    && selectedAdvert.remark && selectedAdvert.remark.length > 0;
  const remarkContent = selectedAdvert && selectedAdvert.remark;
  const formattedDate = getFormattedDateString(updatedAt, 'shorten', '-'); // @suppress longLineCheck

  const validHotlines = hotlines.filter(
    (hotline: string) => hotline.trim() !== '',
  );
  const contactNumber = whatsAppNumber || (validHotlines[0] || null);
  const message = encodeURIComponent(`Hi, I saw the ${name} on Sgcarmart. May I know what is the latest promo?`);

  const handleAdditionalInfoClick = () => {
    onRemarkClick(id);
  };

  return (
    <div className={cx(
      styles.containerRoot,
    )}>
      <div className={styles.containerLeftColumn}>
        <div className={styles.textPiName}>
          <TextLink
            href={getInternalLink(piDealerLink, 'carinfo')}
            text={name} />
        </div>
        {hasStocks
        && (
          <ListTypeLabel
            className={styles.containerHasStockLabel}
            labelSize={LIST_TYPE_LABEL_SIZE}
            type="readyStocks" />
        )}
        <div className={styles.containerPhones}>
          {contactNumber && (
            <ContactItem
              contactType="hotline"
              displayMode="default"
              fontSize="small"
              list={[contactNumber]} />
          )}
        </div>
        {
          whatsAppNumber && (
            <ContactItem
              contactType="sms"
              displayMode="default"
              fontSize="small"
              iconSize={ICON_SIZE_IN_PIXEL}
              list={[`${whatsAppNumber}&body=${message}`]} />
          )
        }
        <div className={styles.containerContacts}>
          {
            whatsAppNumber && (
              <ContactItem
                contactType="whatsApp"
                displayMode="default"
                fontSize="small"
                iconSize={ICON_SIZE_IN_PIXEL}
                list={[`${whatsAppNumber}&text=${message}`]}
                target="_blank" />
            )
          }
        </div>
      </div>
      <div className={styles.containerRightColumn}>
        <div className={cx(
          styles.containerPrice,
          styles.isSemiBoldRed,
        )}>
          {selectedAdvert && selectedAdvert.price !== 0
            ? convertPriceToText(selectedAdvert.price)
            : <span>POA</span>}
          {hasRemark && isDesktopMode
          && (
            <Tooltip
              className={cx(
                styles.containerTooltip,
              )}
              content={(
                <div>
                  {remarkContent}
                </div>
              )}>
              <button
                className={styles.buttonAdditionalInfo}>
                <Image
                  alt="icon image"
                  className={styles.imageHoverIcon}
                  height={14}
                  src={`${joinSgcmMedia('/public/new-cars/icon/iconRedAdd.svg')}`}
                  width={14} />
              </button>
            </Tooltip>
          )}
          {hasRemark && !isDesktopMode
          && (
            <button
              className={styles.buttonAdditionalInfo}
              onClick={handleAdditionalInfoClick}>
              <Image
                alt="icon image"
                className={styles.imageHoverIcon}
                height={14}
                src={`${joinSgcmMedia('/public/new-cars/icon/iconRedAdd.svg')}`}
                width={14} />
            </button>
          )}
        </div>
        <div className={styles.pricingSchema}>
          {piDealer.pricingSchema}
        </div>
        <div className={cx(
          styles.textUpdatedAt,
          styles.isGray,
        )}>
          {`Price Updated: ${formattedDate}`}
        </div>
      </div>
    </div>
  );
};
